import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { WhatsAppIcon } from "./icons";
import { waLink, WHATSAPP_URL } from "./config";

const CATEGORIES = [
  {
    name: "Insumos y Harinas Especiales",
    sub: "Esencias, coberturas, fondant, granillos",
    img: "https://images.unsplash.com/photo-1516746924755-babd21844370?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxjYWtlJTIwZGVjb3JhdGluZyUyMHRvb2xzJTIwcGlwaW5nJTIwbm96emxlcyUyMGZvbmRhbnQlMjBzcHJpbmtsZXMlMjBjb2xvcmZ1bCUyMGJha2VyeSUyMHN1cHBseXxlbnwwfHx8fDE3OTI5NjExNjd8MA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-2",
  },
  {
    name: "Herramientas de Modelado",
    sub: "Cortadores, alisadores, rodillos con textura",
    img: "https://images.unsplash.com/photo-1725524089635-4c4e35b19ada?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxiYWtpbmcldm1vbGRzJTIwc2lsaWNvbmUlMjBjYWtlJTIwcGFucyUyMHBhc3RyeSUyMHV0ZW5zaWxzfGxufDB8fHwxNzkyOTYxMTczfDA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-2",
  },
  {
    name: "Boquillas y Mangas Pasteleras",
    sub: "Sets de precisión para decoración profesional",
    img: "https://images.unsplash.com/photo-1669221262092-5fd1232482b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxjYWtlJTIwZGVjb3JhdGluZyUyMHRvb2xzJTIwcGlwaW5nJTIwbm96emxlcyUyMGZvbmRhbnQlMjBzcHJpbmtsZXMlMjBjb2xvcmZ1bCUyMGJha2VyeSUyMHN1cHBseXxlbnwwfHx8fDE3OTI5NjExNjd8MA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-2",
  },
  {
    name: "Moldes y Capacillos",
    sub: "Diferentes tamaños y materiales para horneado perfecto",
    img: "https://images.unsplash.com/photo-1658312286798-7c5c2959b96b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxiYWtpbmcldm9sZHMlMjBzaWxpY29uZSUyMGNha2UlMjBwYW5zJTIwcGFzdHJ5JTIwdXRlbnNpbHN8ZW58MHx8fDE3OTI5NjExNzN8MA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-3",
  },
  {
    name: "Accesorios y Empaques",
    sub: "Bases, cajas y elementos decorativos finales",
    img: "https://images.unsplash.com/photo-1677840147144-4e9bf3adc284?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxwYXN0cnklMjBjaGVmJTIwZGVjb3JhdGluZyUyMGNha2UlMjBmcm9zdGluZyUyMHBpbmslMjBzdHJhd2JlcnJ5JTIwZGVzc2VydHxlbnwwfHx8fDE3OTI5NjExNzN8MA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-3",
  },
];

export default function Categories() {
  return (
    <section id="categorias" className="bg-cream2 py-14 sm:py-18 lg:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
        <div className="mx-auto max-w-2xl text-center">
          <Reveal>
            <Eyebrow>Navegación visual rápida</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-display text-3xl font-semibold leading-tight tracking-tight text-choco sm:text-4xl lg:text-5xl">
              Encuentra exactamente lo que necesitas
            </h2>
          </Reveal>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-6 lg:gap-7">
          {CATEGORIES.map((c, i) => (
            <Reveal
              key={c.name}
              delay={i * 0.08}
              className={`${c.span} h-full ${i < 3 && i === 2 ? "sm:col-span-2" : ""}`}
            >
              <a
                data-testid={`category-card-${i}`}
                href={waLink(
                  `Hola Global Pastel, quisiera consultar disponibilidad y precios de: ${c.name}`
                )}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex h-full flex-col overflow-hidden rounded-[1.75rem] border border-linebr bg-white transition duration-300 hover:-translate-y-2 hover:shadow-[0_35px_70px_-30px_rgba(44,32,28,0.4)]"
              >
                <div className="relative h-40 overflow-hidden sm:h-44">
                  <img
                    src={c.img}
                    alt={c.name}
                    loading="lazy"
                    className="h-full w-full object-cover transition duration-700 group-hover:scale-[1.07]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-choco/45 via-transparent to-transparent" />
                  <span className="absolute left-4 top-4 rounded-full bg-cream/90 px-3 py-1 text-[11px] font-bold tracking-widest text-choco backdrop-blur">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="absolute bottom-4 right-4 flex h-10 w-10 items-center justify-center rounded-full bg-wagreen text-white opacity-0 shadow-lg transition duration-300 group-hover:opacity-100">
                    <WhatsAppIcon className="h-5 w-5" />
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-5 sm:p-6">
                  <h3 className="font-display text-lg font-semibold text-choco sm:text-xl">
                    {c.name}
                  </h3>
                  <p className="mt-1 flex-1 text-sm leading-relaxed text-cocoa">
                    {c.sub}
                  </p>
                  <span className="mt-3 inline-flex items-center gap-1.5 text-sm font-bold text-rose">
                    Consultar por WhatsApp
                    <ArrowUpRight className="h-4 w-4 transition duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15} className="mt-9 text-center">
          <a
            data-testid="categories-whatsapp-cta"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 rounded-full bg-choco px-9 py-4 text-base font-bold text-cream transition duration-300 hover:-translate-y-1 hover:bg-rose"
          >
            <WhatsAppIcon className="h-5 w-5" />
            Consulta Disponibilidad y Precios por WhatsApp
          </a>
        </Reveal>
      </div>
    </section>
  );
}
